// 지역(국내/해외) 판정 — 순수 좌표 기반 (수동 선택 없이 위치로 자동 결정)
// 날씨/지도/검색/역지오코딩 분기의 단일 진실원. 각 좌표마다 독립 판정되므로
// 일정 목록에 국내·해외가 섞여 있어도 항목별로 알맞은 API로 조회된다.

import { isDomestic } from './regionUtil';

export const resolveDomestic = (lat, lng) => isDomestic(lat, lng);
